'use client';

import React from 'react';
import { Form, Button, Checkbox } from 'antd';
import Image from 'next/image';
import Highlight from '@/components/ui/Highlight';
import bindLogo from '../../../public/assets/bind-logo.png';

import classes from './onboardingDefault.module.scss';

interface Props {
  form: any;
  logo: string;
  tyc: string;
  handleSubmit: () => void;
  openTyC: () => void;
  type?: string;
  /**
   * No pedir la aceptacion de terminos en esta pantalla (AB#10758). La regla la decide page.tsx y
   * llega resuelta para que el render y la validacion del boton no puedan divergir.
   */
  ocultarTerminos?: boolean;
}

const OnboardingVirginia: React.FC<Props> = ({ form, logo, tyc, handleSubmit, openTyC, type, ocultarTerminos }) => {
  return (
    <div className={classes.container}>
      {/* Logo */}
      <div className={classes.logoContainer}>
        {/* AB#11070: logo puede llegar null/vacio; next/image explota con src null. */}
        <Image src={logo || bindLogo} alt="Logo" width={500} height={500} className={classes.logo} />
      </div>

      {/* Título principal */}
      <h1 className={classes.mainTitle}>
        ¡Bienvenido a <Highlight> Mundo Virginia!</Highlight>
      </h1>

      {/* Descripción */}

      <p className={classes.description}>
        {type === 'juridico'
          ? 'Para que puedas descargarte la aplicación, necesitamos validar información de tu comercio y de tu identidad. Te tomará pocos minutos. Recordá también que es necesario tener una actividad económica en ARCA.'
          : 'Para que puedas descargarte la aplicación, necesitamos validar tu identidad. Te tomará pocos minutos. Te recomendamos tener a mano tu DNI y ubicarte en un lugar con buena luz. Recordá también que es necesario tener una actividad económica en ARCA.'}
      </p>

      {/* Formulario */}
      <Form form={form} onFinish={handleSubmit} className={classes.form}>
        {/* Se oculta la fila completa, check y link. No es que no se puedan leer los terminos: es
            que la aceptacion no le corresponde a quien tiene la pantalla adelante. En el flujo
            juridico la presta el representante legal, con autoria y fecha (RF-ONB-19). */}
        {!ocultarTerminos && (
          <Form.Item name="tyc" valuePropName="checked" className={classes.formItem}>
            <div className={classes.terms}>
              <Checkbox style={{ marginRight: '5px', alignSelf: 'flex-start' }} />
              <span className={classes.termsText}>
                Acepto los{' '}
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    openTyC();
                  }}
                  style={{ fontWeight: 'bold', cursor: 'pointer', textDecoration: 'underline' }}
                >
                  <Highlight>Términos y Condiciones</Highlight>
                </a>
              </span>
            </div>
          </Form.Item>
        )}

        <Button className={classes.btnInicio} type="primary" htmlType="submit">
          Iniciar
        </Button>
      </Form>
    </div>
  );
};

export default OnboardingVirginia;
